module.exports = __webpack_public_path__ + "img/ozon.2f38a9c4.png";